import React, { useEffect } from 'react';
import { HomePage } from './pages/HomePage';
import { LanguageProvider } from './hooks/useLanguage';
function AppContent() {
  useEffect(() => {
    document.title = 'WarpWork — Gameplay Programmer Freelance';
  }, []);
  return <HomePage data-id="element-0" />;
}
export function App() {
  return <LanguageProvider data-id="element-1">
      <AppContent data-id="element-2" />
    </LanguageProvider>;
}